import { useState, useEffect } from "react";
import api from "@/lib/api";

import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ProblemsSection from "../components/ProblemsSection";
import ServicesSection from "../components/ServicesSection";
import ProcessSection from "../components/ProcessSection";
import BenefitsSection from "../components/BenefitsSection";
import ShowcaseSection from "../components/ShowcaseSection";
import ClientSitesSection from "../components/ClientSitesSection";
import DemoGalleryModal from "../components/DemoGalleryModal";
import CtaSection from "../components/CtaSection";
import Footer from "../components/Footer";
import Faq from "@/components/Faq";

import SeoHead from "@/components/SeoHead";
import SolutionsSection from "@/components/SolutionsSection";

export default function HomePage() {
  const [business, setBusiness] = useState(null);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const [publicConfig, setPublicConfig] = useState({ recaptcha: { enabled: false } });

  useEffect(() => {
    const fetchBusiness = async () => {
      try {
        const res = await api.get("/business");
        setBusiness(res.data);
      } catch (error) {
        console.error("Eroare la încărcarea SEO business:", error);
      }
    };

    fetchBusiness();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/public-config");
        setPublicConfig(res.data || { recaptcha: { enabled: false } });

        const sitekey = res.data?.recaptcha?.sitekey;
        const enabled = res.data?.recaptcha?.enabled;

        if (enabled && sitekey) {
          const { loadRecaptchaV3 } = await import("../recaptcha");
          await loadRecaptchaV3(sitekey);
        }
      } catch (error) {
        console.error("Eroare la încărcarea configurării publice:", error);
        setPublicConfig({ recaptcha: { enabled: false } });
      }
    })();
  }, []);

  return (
    <>
      <SeoHead seo={business?.seo} />
      <DemoGalleryModal
        isOpen={isDemoModalOpen}
        onClose={() => setIsDemoModalOpen(false)}
      />
      <main className="rz-page">
        <Header />
        <HeroSection
          onOpenDemo={() => setIsDemoModalOpen(true)}
          publicConfig={publicConfig}
        />
        <ProblemsSection />
        <SolutionsSection />
        <BenefitsSection />
        <ServicesSection />
        <ProcessSection />
        {/* <ShowcaseSection onOpenDemo={() => setIsDemoModalOpen(true)} /> */}
        <ClientSitesSection />
        <CtaSection />
        <Faq />
        <Footer />
      </main>
    </>
  );
}
